import { os } from "@/hive-vue3/utils/browserPlatform";
import { useKeyModifier } from "@vueuse/core";

const isMac = os.isMac();
export default function () {
  if (isMac) return useKeyModifier("Meta");
  else return useKeyModifier("Control");
}
